import {DOC_STATUSES} from '../constants/documentCollection';

/**
 * Derives an aggregated status for the single-document insurance history card.
 *
 * Priority:
 * 1. Return REQUIRED when there are no insurance-history documents.
 * 2. If any document is NOT_APPROVED, return NOT_APPROVED.
 * 3. If every document is APPROVED, return APPROVED.
 * 4. If every document is either IN_REVIEW or ACCEPTED, return IN_REVIEW.
 * 5. Otherwise return REQUIRED.
 */
export const getSingleInsuranceHistoryStatus = (insuranceHistoryDocs) => {
  if (!insuranceHistoryDocs || insuranceHistoryDocs.length === 0) return DOC_STATUSES.REQUIRED;
  const statuses = insuranceHistoryDocs.map((doc) => doc.status);
  if (statuses.some((s) => s === DOC_STATUSES.NOT_APPROVED)) return DOC_STATUSES.NOT_APPROVED;
  if (statuses.every((s) => s === DOC_STATUSES.APPROVED)) return DOC_STATUSES.APPROVED;
  if (statuses.every((s) => s === DOC_STATUSES.IN_REVIEW || s === DOC_STATUSES.ACCEPTED)) return DOC_STATUSES.IN_REVIEW;
  return DOC_STATUSES.REQUIRED;
};

/**
 * Computes the active progress step for the document collection stepper.
 *
 * Steps:
 * 0 = upload
 * 1 = in review
 * 2 = completion required (rejected document)
 * 3 = completed
 */
export const getDocumentCollectionActiveStep = ({baseDocs, insuranceHistoryDocs, idIssuanceDateProvided}) => {
  const allDocs = [...baseDocs, ...insuranceHistoryDocs];
  if (allDocs.length === 0) return 0;

  const effectiveStatuses = allDocs.map((doc) => {
    if (doc.type === 'insurance_history' && idIssuanceDateProvided) {
      return DOC_STATUSES.APPROVED;
    }
    return doc.status;
  });

  if (effectiveStatuses.every((s) => s === DOC_STATUSES.APPROVED)) return 3;
  if (effectiveStatuses.some((s) => s === DOC_STATUSES.NOT_APPROVED)) return 2;
  if (effectiveStatuses.some((s) => s === DOC_STATUSES.IN_REVIEW || s === DOC_STATUSES.ACCEPTED)) return 1;
  return 0;
};
